import { useTranslation } from 'react-i18next';
import { GrispiInputProps } from '..';
import { reverseStatusMap, statusOptions } from '../../../model/types';
import GrispiSelectInput from './GrispiSelectInput/index';

type GrispiStatusInputProps = Omit<GrispiInputProps<'STATUS'>, 'type'>;

const GrispiStatusInput = ({ options, actionInput, ...rest }: GrispiStatusInputProps) => {
    const { t } = useTranslation('common');
    const defaultOptions = Object.entries(statusOptions)
        .map(([key, value]) => ({
            key,
            value: reverseStatusMap[key].toString(),
            label: t(`ticketStatus.${value}`)
        }))
        .filter((statusOption) => !(actionInput && statusOption.key === statusOptions.New));

    return <GrispiSelectInput {...rest} options={options?.length < 1 ? defaultOptions : options ?? defaultOptions} />;
};

export default GrispiStatusInput;
